import {WeeklyDish} from "../Types/WeeklyDish";

const BASE_URL = `${process.env.REACT_APP_API_URL ?? ""}/api/WeeklyMenu`;

export type AddWeeklyMenuItemPayload = {
  menuItemId: number;
  dishAmount: number;
};

export type EditWeeklyMenuItemPayload = {
  weekId: number;
  dishAmount: number;
};

export async function getAllWeeklyItems(): Promise<WeeklyDish[]> {
  const res = await fetch(`${BASE_URL}/GetAllWeeklyItems`);
  if (!res.ok) throw new Error("Failed to fetch weekly menu items");
  return res.json();
}

export async function addWeeklyItem(item: AddWeeklyMenuItemPayload): Promise<WeeklyDish> {
  const res = await fetch(`${BASE_URL}/AddWeeklyItem`, {
    method: "POST",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to add weekly menu item");

  return res.json();
}

export async function editWeeklyItem(item: EditWeeklyMenuItemPayload): Promise<WeeklyDish> {
  const res = await fetch(`${BASE_URL}/EditWeeklyItem`, {
    method: "PUT",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to edit weekly menu item");

  return res.json();
}

export async function deleteWeeklyItem(weekId: number): Promise<boolean> {
  const res = await fetch(`${BASE_URL}/DeleteWeeklyItem`, {
    method: "DELETE",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(weekId),
  });

  if (!res.ok) throw new Error("Failed to delete weekly menu item");
  return res.json();
}
